import { Component, Inject, OnInit, Input, ElementRef, ViewChild  } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ParamMap } from '@angular/router';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder } from "@angular/forms";
import { User, Owner } from '../../../modele/user/userModel';
import {SnackbarComponent} from '../../../components/alerts/snackbar/snackbar.component';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import {BoardService} from "../../../services/board/board.service";
import {EndpointService} from "../../../services/endpoint/endpoint.service";
import {UserService} from "../../../services/user.service";
declare let html2canvas: any;

//import * as html2canvas from 'html2canvas';



@Component({
  selector: 'app-image-creator',
  templateUrl: './image-creator.component.html',
  styleUrls: ['./image-creator.component.scss']
})
export class ImageCreatorComponent implements OnInit {
    public screenname: string;
    public image: string;
    title = 'app';
    elementType = 'url';
    value = '';
    @ViewChild('screen') screen: ElementRef;
  @ViewChild('canvas') canvas: ElementRef;
  @ViewChild('downloadLink') downloadLink: ElementRef;


  constructor(
      private formBuilder: FormBuilder,
      private router: Router,
      private snackBar: MatSnackBar,
      private endpointSrv: EndpointService,
      public dialogRef: MatDialogRef<ImageCreatorComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      public userService: UserService
  ) {
      setTimeout(()=>{
          this.value = "https://whooosh.com/"+this.screenname
      },1000)

   }

  ngOnInit(): void {
  }
  downloadImage(){
   html2canvas(this.screen.nativeElement).then(canvas => {
     this.canvas.nativeElement.src = canvas.toDataURL();
     this.downloadLink.nativeElement.href = canvas.toDataURL('image/png');
     this.downloadLink.nativeElement.download = 'whooosh_card.jpg';
     this.downloadLink.nativeElement.click();
   });
 }

}
